import { render, staticRenderFns } from "./AttendancePayrollPostingLog.vue?vue&type=template&id=778a451e"
import script from "./AttendancePayrollPostingLog.vue?vue&type=script&lang=js"
export * from "./AttendancePayrollPostingLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports